import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@rtkwlf/pro-solid-svg-icons/faExclamationTriangle';

import { Stack } from '../../../components/stack';
import { Typography } from '../../../components/typography';
import { useFenrirTranslation } from '../../../locales/use-fenrir-translation';

export const ErrorDataUnavailable = () => {
  const { t } = useFenrirTranslation({
    keyPrefix: 'errors.errorDataUnavailable',
  });

  return (
    <Stack
      spacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
        width: '100%',
        height: '100%',
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          size="2x"
          color="var(--aw-palette-arcticGrey-400)"
        />
        <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
          {t('title')}
        </Typography>
      </Stack>
      <Typography
        color="textSecondary"
        sx={{ textAlign: 'center', whiteSpace: 'pre-line' }}
      >
        {t('body')}
      </Typography>
    </Stack>
  );
};
